const MENU_LOGO_SRC = `${process.env.PUBLIC_URL || ""}/logobinder.png`;
const MENU_LOGO_ALT = "Binder Logo";

export { MENU_LOGO_SRC, MENU_LOGO_ALT };
